import { gql } from "@apollo/client";

export const MUTATION_UPDATE_MATERIAL_TRACKING = gql`
  mutation bulkSubmittalMaterialTracking(
    $featureInstanceIds: [String!]!
    $material_tracking: Boolean!
  ) {
    update_features_link_tracking(
      feature_instance_ids: $featureInstanceIds
      feature_tracking: $material_tracking
    ) {
      message
    }
  }
`;
